export default __webpack_public_path__ + "static/media/phone.bd2bd8db.png";